import React, { useEffect } from 'react'
import '../UserRegistrationScene/index.scss'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import { useLocation } from 'react-router'

const Au10TixVerificationScene = () => {
    useEffect(() => {
        analyticsSendPage('user_registration_complete')
    }, [])
    const location = useLocation()
    const BASE_AU10TIX_WORKFLOW_URL = window.APP_CONFIG.AU10TIX_WORKFLOW_ROOT_URI

    const buildAu10TixWorkflowUrl = (): string => `${BASE_AU10TIX_WORKFLOW_URL}${location.search}`

    return (
        <>
            <title>User registration</title>
            <main className="user-registration-scene">
                <iframe allow="geolocation;camera; " id="iframe" name="iframe" src={buildAu10TixWorkflowUrl()} />
            </main>
        </>
    )
}

export default Au10TixVerificationScene
